
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/politica-de-privacidade",
      function () {
        return require("private-next-pages/legal/politica-de-privacidade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/politica-de-privacidade"])
      });
    }
  